import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ciment-management',
  templateUrl: './ciment-management.component.html',
  styleUrls: ['./ciment-management.component.css']
})
export class CimentManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
